<template>
  <div class="container">
    <div class="content">
      <div class="header">
        <img class="back" alt="Back button" src="~@/assets/images/back.png" @click="$router.push({ name: 'home' })">
        <p>Stap 1 / 3</p>
        <h1><strong>Maak je keuze</strong></h1>
      </div>
      <div class="group">
        <ck-button class="small" action="Ik ontving reeds een offerte" @click.native="continueCustomer" />
        <ck-button class="small" action="Ik ben (nog) geen klant" @click.native="continueGuest" />
      </div>
      <p>Vraag eerst een offerte aan één van onze medewerkers, en verdubbel je kans om te winnen!</p>
    </div>
  </div>
</template>

<script>
export default {
    methods: {
        logVisit() {
            this.$store.dispatch("logVisit");
        },
        continueGuest() {
            this.$store.commit("setFlowGuest");
            this.$router.push({ name: "new-step-2" });
        },
        continueCustomer() {
            this.$store.commit("setFlowCustomer");
            this.$router.push({ name: "known-step-2" });
        }
    }
};
</script>
